import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
export function CtaFooter() {
  return <footer id="inspect" className="w-full bg-cream border-t border-charcoal/10 pt-24 md:pt-32 pb-10 px-6 relative overflow-hidden" data-id="element-17">
      <div className="max-w-4xl mx-auto relative" data-id="element-18">
        {/* CTA Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="flex flex-col items-center text-center max-w-2xl mx-auto" data-id="element-19">
          <h2 className="font-display text-3xl md:text-4xl mb-5 tracking-wide text-charcoal leading-tight" data-id="element-20">
            Inspect or Bid
          </h2>

          <p className="text-ink-soft font-serif italic text-base md:text-[17px] mb-10 leading-[1.6]" data-id="element-21">
            Step through the door this June — or place your bid on auction day.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto mb-20" data-id="element-22">
            <button className="group flex items-center justify-center gap-2 bg-terracotta text-cream px-7 py-3 text-[10px] font-medium tracking-[0.25em] uppercase hover:bg-charcoal transition-colors duration-300 w-full sm:w-auto" data-id="element-23">
              Book Inspection
              <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" strokeWidth={1.5} data-id="element-24" />
            </button>
            <button className="group flex items-center justify-center gap-2 bg-transparent border border-charcoal/20 text-charcoal px-7 py-3 text-[10px] font-medium tracking-[0.25em] uppercase hover:border-charcoal transition-all duration-300 w-full sm:w-auto" data-id="element-25">
              Auction Details
              <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" strokeWidth={1.5} data-id="element-26" />
            </button>
          </div>
        </motion.div>

        {/* Footer rail */}
        <div className="pt-8 border-t border-charcoal/10 flex flex-col md:flex-row items-center justify-between gap-3 text-center" data-id="element-27">
          <span className="font-serif italic text-xs md:text-sm text-ink-soft" data-id="element-28">
            1 Lanoma Court · Wheelers Hill · VIC
          </span>
          <span className="text-[9px] md:text-[10px] uppercase tracking-[0.25em] text-ink-soft/60" data-id="element-29">
            © 2026
          </span>
        </div>
      </div>
    </footer>;
}